"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountUpdateSchema = exports.BankAccountLinkUpdateSchema = exports.BankAccountDetailsUpdateSchema = exports.BANK_ACCOUNT_PURPOSES = void 0;
const yup = __importStar(require("yup"));
const PURPOSE_REQUIRED = "Please specify the account purpose";
const ACCOUNT_NAME_MANDATORY = "Please enter an account name";
const ACCOUNT_NAME_NOT_ALLOWED = "The settlement purpose has no account name";
const BSB_MANDATORY = "Please enter a BSB";
const BSB_INVALID = "BSB must be exactly 6 digits";
const ACCOUNT_NUMBER_MANDATORY = "Please enter an account number";
const ACCOUNT_NUMBER_SUBSCRIPTION_INVALID = "Account number must be 6 to 12 digits";
const ACCOUNT_NUMBER_SETTLEMENT_INVALID = "Account number must be 6 to 9 digits";
const FI_CODE_MANDATORY = "Please enter an FI code";
const FI_CODE_NOT_ALLOWED = "FI code only applies to the settlement purpose";
const FI_CODE_INVALID = "FI Code must be 2 to 3 alphanumeric characters";
const APCA_ID_MANDATORY = "Please enter an APCA ID";
const APCA_ID_NOT_ALLOWED = "APCA ID only applies to the settlement purpose";
const APCA_ID_INVALID = "APCA ID must be exactly 6 digits";
const LINK_STATE_REQUIRED = "Please specify the link state";
exports.BANK_ACCOUNT_PURPOSES = ["subscription", "distributionSettlement"];
const bsbDigitCount = (bsb) => (bsb ? bsb.replace(/-/g, "").length : 0);
exports.BankAccountDetailsUpdateSchema = yup.object().shape({
    purpose: yup.string().oneOf(exports.BANK_ACCOUNT_PURPOSES, PURPOSE_REQUIRED).required(PURPOSE_REQUIRED),
    accountName: yup.string().when("purpose", {
        is: "subscription",
        then: (schema) => schema.trim(ACCOUNT_NAME_MANDATORY).required(ACCOUNT_NAME_MANDATORY),
        otherwise: (schema) => schema.test("not-allowed", ACCOUNT_NAME_NOT_ALLOWED, (value) => value === undefined),
    }),
    // BSB and account number are mandatory for the subscription purpose (one full account per
    // save). For the settlement purpose they are optional at the schema layer — submitted only
    // when the purpose is unlinked and its own values are being changed; the controller rejects
    // either one being present while the purpose is linked. fiCode/apcaId stay editable on their
    // own regardless.
    bsb: yup
        .string()
        .trim(BSB_MANDATORY)
        .when("purpose", {
        is: "subscription",
        then: (schema) => schema.required(BSB_MANDATORY),
    })
        .test("six-digits", BSB_INVALID, (bsb) => bsb === undefined || bsbDigitCount(bsb) === 6)
        .test("format", BSB_INVALID, (bsb) => bsb === undefined || /^\d{3}-?\d{3}$/.test(bsb)),
    accountNumber: yup
        .string()
        .trim(ACCOUNT_NUMBER_MANDATORY)
        .when("purpose", {
        is: "subscription",
        then: (schema) => schema.required(ACCOUNT_NUMBER_MANDATORY).matches(/^\d{6,12}$/, ACCOUNT_NUMBER_SUBSCRIPTION_INVALID),
        otherwise: (schema) => schema.test("format", ACCOUNT_NUMBER_SETTLEMENT_INVALID, (value) => value === undefined || /^\d{6,9}$/.test(value)),
    }),
    fiCode: yup.string().when("purpose", {
        is: "distributionSettlement",
        then: (schema) => schema
            .trim(FI_CODE_MANDATORY)
            .required(FI_CODE_MANDATORY)
            .matches(/^[A-Za-z0-9]{2,3}$/, FI_CODE_INVALID),
        otherwise: (schema) => schema.test("not-allowed", FI_CODE_NOT_ALLOWED, (value) => value === undefined),
    }),
    apcaId: yup.string().when("purpose", {
        is: "distributionSettlement",
        then: (schema) => schema
            .trim(APCA_ID_MANDATORY)
            .required(APCA_ID_MANDATORY)
            .matches(/^\d{6}$/, APCA_ID_INVALID),
        otherwise: (schema) => schema.test("not-allowed", APCA_ID_NOT_ALLOWED, (value) => value === undefined),
    }),
});
exports.BankAccountLinkUpdateSchema = yup.object().shape({
    purpose: yup.string().oneOf(["distributionSettlement"], PURPOSE_REQUIRED).required(PURPOSE_REQUIRED),
    linkedToSubscriptionAccount: yup.boolean().required(LINK_STATE_REQUIRED),
});
exports.BankAccountUpdateSchema = yup.lazy((value = {}) => "linkedToSubscriptionAccount" in value ? exports.BankAccountLinkUpdateSchema : exports.BankAccountDetailsUpdateSchema);
//# sourceMappingURL=BankAccountsSchema.js.map